import { attr } from '@ember-data/model';
import { fragment } from 'ember-data-model-fragments/attributes';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
import OnlineStoreItemType from '@square/dashboard-items-data/models/online-store-item-type';
export default EmberDataBaseFragment.extend({
  version: attr('number'),
  type: attr('enum', {
    enumClass: OnlineStoreItemType
  }),
  eventData: fragment('online-store-event-data')
}).reopenClass({
  _modelNameForMigration: 'online-store-item-data'
});